import React, { useEffect } from 'react';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { MinimalSidebar } from '@/components/sidebars/MinimalSidebar';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useAdminData } from '@/hooks/useAdminData';

interface AdminLayoutProps {
  children: React.ReactNode;
  activeTab?: string; // Optional since MinimalSidebar handles active state internally via URL
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const adminData = useAdminData();

  useEffect(() => {
    adminData.fetchTotalCounts();
  }, []);

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-background">
        <MinimalSidebar onSignOut={handleSignOut} />
        <SidebarInset className="flex-1">
          {children}
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default AdminLayout;
